import * as React from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";
/* eslint-disable*/
const CurrencyNumber = (props) => {
  const { value, currency, showSign, ...rest } = props;
  return (
    <React.Fragment>
      {showSign && value > 0 ? "+" : ""}
      <FormattedNumber
        value={value}
        currency={currency}
        style="currency"
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      >
        {(value) => value}
      </FormattedNumber>
    </React.Fragment>
  ); //
};
/* eslint-enable*/

CurrencyNumber.propTypes = {
  value: PropTypes.number.isRequired,
  currency: PropTypes.string,
  showSign: PropTypes.bool,
};

CurrencyNumber.defaultProps = {
  currency: "USD",
  showSign: false,
};

export default CurrencyNumber;



// WEBPACK FOOTER //
// ./src/components/UI/CurrencyNumber.jsx